import { AppAccent } from 'src/app/core/types/app-accent.type';
import { AppVisualContextService } from '../../services/app-visual-context.service';
import { HostBinding, inject, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { NullSafe } from 'src/app/core/types/null-safe.type';

@Component({
  selector: 'app-item-selection-accordion',
  templateUrl: './item-selection-accordion.component.html',
  styleUrl: './item-selection-accordion.component.css',
})
export class ItemSelectionAccordionComponent {
  // Atributos personalizados para o componente
  @Input() accent?: AppAccent;
  private readonly visualContext = inject(AppVisualContextService);
  @HostBinding('class') get visualClass(): string {
    return this.accent === undefined ? '' : this.visualContext.classForInputs(this.accent);
  }

  @Input({ required: true }) title: NullSafe<string>;
  @Input() selected?: boolean;
  @Input() button?: {
    icon?: string;
    icon2?: string;
    label: string;
    label2?: string;
  };
  // Aceita qualquer template
  @Input() headerContent?: TemplateRef<any>;
  @Input() headerContentWidth: 'default' | 'compact' = 'default';
  get headerContentClass(): string {
    return `header-content-width-${this.headerContentWidth === 'compact' ? 45 : 65}`;
  }

  // Eventos personalizados para os botões
  @Output() buttonClick = new EventEmitter<void>();

  protected buttonClicked(event: MouseEvent): void {
    event.stopPropagation();
    this.buttonClick.emit();
  }
}
